module.exports = __webpack_public_path__ + "img/empty-history.9fc5e803.svg";